import React from 'react';
import ImagePoll from './imagePoll';
import TextPoll from './textPoll';

const PollOptions = ({
  handleSubmitPoll,
  pollId,
  index,
  showResult,
  pollType,
  disablePollOption,
  options,
}) => {
  return (
    <React.Fragment>
      {pollType === 'IMAGE' && (
        <ImagePoll
          pollId={pollId}
          options={options}
          handleSubmitPoll={handleSubmitPoll}
          showResult={showResult}
          disablePollOption={disablePollOption}
        />
      )}

      {pollType === 'TEXT' && (
        <TextPoll
          pollId={pollId}
          disablePollOption={disablePollOption}
          handleSubmitPoll={handleSubmitPoll}
          index={index}
          showResult={showResult}
          options={options}
        />
      )}
    </React.Fragment>
  );
};
export default PollOptions;
